import { render, staticRenderFns } from "./MetadataConflictTable.vue?vue&type=template&id=bfe0bdc0&"
import script from "./MetadataConflictTable.vue?vue&type=script&lang=js&"
export * from "./MetadataConflictTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports